import React from 'react'

import {TherapistSpecialty} from '@/api/models'
import DataTable from '@/common/data-table'
import useTableState from '@/common/data-table/use-table-state'
import {editAction, deleteAction} from '@/common/data-table/utils'
import DeleteResourceModal from '@/common/delete-resource-modal'
import useSupabaseQuery from '@/common/use-custom-query'
import useValueDisclosure from '@/common/use-value-disclosure'

import {columns, filterFields, emptyTherapistSpecialty} from './constants'
import TherapistSpecialtyEditor from './editor-modal'

const TherapistSpecialties = () => {
  const tableState = useTableState({descending: true, sortBy: 'updated_at'})
  const {loading, data, fetch, rows} = useSupabaseQuery<TherapistSpecialty>({
    descending: tableState.descending,
    fields: '*',
    filter: tableState.filter,
    itemsPerPage: tableState.rowsPerPage,
    order: tableState.sortBy.column as keyof TherapistSpecialty,
    pageNumber: tableState.page,
    table: 'therapist_specialties',
  })

  const {
    value: deleteValue,
    onClose: onDeleteClose,
    onOpen: onDeleteOpen,
  } = useValueDisclosure<TherapistSpecialty>()

  const {
    value: editorValue,
    onClose: onEditorClose,
    onOpen: onEditorOpen,
  } = useValueDisclosure<TherapistSpecialty>()

  const actions = React.useMemo(
    () => [editAction(onEditorOpen), deleteAction(onDeleteOpen)],
    [onDeleteOpen, onEditorOpen]
  )

  const handleAdd = React.useCallback(() => {
    onEditorOpen(emptyTherapistSpecialty)
  }, [onEditorOpen])

  return (
    <>
      <DataTable<TherapistSpecialty>
        columns={columns}
        data={data ?? []}
        totalCount={rows}
        tableState={tableState}
        actions={actions}
        onRefresh={fetch}
        onAdd={handleAdd}
        loading={loading}
        filterFields={filterFields}
      />
      <TherapistSpecialtyEditor
        onClose={onEditorClose}
        open={!!editorValue}
        item={editorValue}
        onComplete={fetch}
      />
      <DeleteResourceModal
        table="therapist_specialties"
        id={deleteValue?.id || ''}
        onClose={onDeleteClose}
        open={!!deleteValue}
        onComplete={fetch}
      />
    </>
  )
}

export default TherapistSpecialties
